module.exports = __webpack_public_path__ + "img/Patent_2.75560e40.jpg";